import { ConfirmDialog, FormError } from "@/components/kit";
import { Supplier } from "@/types/supplier";

interface DeleteSupplierProps {
  supplier: Supplier;
  isOpen: boolean;
  onOpenChange: (value: boolean) => void;
  onDelete: (id: string) => void;
  isDeleting: boolean;
  /** Why the last attempt failed, shown in the dialog (a supplier that still has products cannot be deleted). */
  error?: string | null;
}

export const DeleteSupplierModal = ({
  isDeleting,
  onDelete,
  isOpen,
  onOpenChange,
  supplier,
  error,
}: DeleteSupplierProps) => {
  return (
    <ConfirmDialog
      confirmLabel="Delete"
      isOpen={isOpen}
      isPending={isDeleting}
      title="Delete supplier?"
      onClose={() => onOpenChange(false)}
      onConfirm={() => onDelete(supplier.id)}
    >
      <div className="flex flex-col gap-3">
        <p>Are you sure you want to delete {supplier?.name}</p>
        <FormError message={error} />
      </div>
    </ConfirmDialog>
  );
};
